import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/send-message-icon.svg'


const _hoisted_1 = { class: "flex w-full max-w-full justify-between items-start flex-row border-t" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = {
  class: "growing-wrapper",
  ref: "textareaWrapper"
}
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "mt-3 flex space-x-2 content-center" }
const _hoisted_6 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmojiHappyIcon = _resolveComponent("EmojiHappyIcon")!
  const _component_PaperClipIcon = _resolveComponent("PaperClipIcon")!
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("textarea", {
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.replicateTextInput && _ctx.replicateTextInput(...args))),
          ref: "textArea",
          class: _normalizeClass([_ctx.backgroundClass, _ctx.placeholderClass]),
          rows: "1",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.text) = $event)),
          onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.sendMessage()), ["exact","prevent"]), ["enter"])),
          placeholder: _ctx.t('messengerEditor.inputPlaceholder')
        }, null, 42, _hoisted_4), [
          [_vModelText, _ctx.text]
        ])
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("a", {
        ref: "emojiPickerButton",
        id: "emoji-button",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleEmojiPicker && _ctx.toggleEmojiPicker(...args))),
        class: "cursor-pointer"
      }, [
        _createVNode(_component_EmojiHappyIcon, {
          class: _normalizeClass([_ctx.emojiButtonClass, "w-7 h-7 transition-colors"])
        }, null, 8, ["class"])
      ], 512),
      (_ctx.canSendMessage)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendMessage())),
            class: _normalizeClass([
          _ctx.canSendMessage
            ? `opacity-100 cursor-pointer ${_ctx.submitButtonClass}`
            : 'opacity-40 text-gray-600 cursor-not-allowed pointer-events-none',
          'transition-opacity mt-0.5',
        ])
          }, [
            _withDirectives(_createElementVNode("img", {
              class: _normalizeClass([
            'inline mr-2 h-6 w-6 transition-colors fill-current align-baseline',
          ]),
              src: _imports_0,
              alt: _ctx.t('messengerEditor.sendAltText')
            }, null, 8, _hoisted_6), [
              [_directive_svg_inline]
            ])
          ], 2))
        : _createCommentVNode("", true),
      (!_ctx.canSendMessage)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            id: "attachment-button",
            class: _normalizeClass(['cursor-pointer block pr-2']),
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
          }, [
            _createVNode(_component_PaperClipIcon, {
              class: _normalizeClass([
            'h-7 w-7 align-baseline transition-colors -ml-1',
            _ctx.attachmentButtonClass,
          ])
            }, null, 8, ["class"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("input", {
      type: "file",
      class: "hidden",
      ref: "fileInput",
      multiple: "",
      onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)))
    }, null, 544)
  ]))
}